<div class="main-screen-container">
    <div *ngIf="isLoading" class="d-flex justify-content-center">
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="errorMessage.isError && !isLoading" class="d-flex align-items-center flex-column">
        <h1>ERROR STATUS: {{errorMessage.message}}</h1>
        <h3>NIE MOŻNA ZAŁADOWAĆ DANYCH</h3>
    </div>
    <div *ngIf="!errorMessage.isError && !isLoading">
        <h3 class="w-100">Zaproszenie: {{invitation.email}}</h3>
        <div class="top-row pb-2">
            <div class="d-flex flex-row gap-3">
                <button mat-flat-button (click)="onBack()"><mat-icon>keyboard_backspace</mat-icon>Powrót</button>
                <!-- <button mat-flat-button>TODO:Wyślij ponownie</button> -->
            </div>

        </div>
        <mat-divider></mat-divider>
        <div class="main-content">

            <table class="info-table">
                <thead >
                    <tr>
                        <td colspan="2"><h5>Główne informacje</h5></td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Rola:</td><td>{{invitation.role_name}}</td></tr>
                    <tr><td>Status:</td><td>{{invitation.status}}</td></tr>
                    <tr><td>Zaproszony przez:</td><td>{{invitation.inviter.name}} {{invitation.inviter.surname}}</td></tr>
                    <tr><td>Utworzone:</td><td>{{invitation.created_at}}</td></tr>
                    <tr *ngIf="invitation.cancelled_at"><td>Usunięte:</td><td>{{invitation.cancelled_at}}</td></tr>
                    <tr *ngIf="invitation.used_at"><td>Wykorzystane:</td><td>{{invitation.used_at}}</td></tr>
                    <tr *ngIf="!invitation.used_at"><td>Ważne do:</td><td>{{invitation.expires_at}}</td></tr>

                </tbody>
            </table>
        </div>
    </div>
</div>
